<template>
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
  >
    <path d="M4.67281 3.68384L6.1939 0.601789C6.3588 0.267662 6.67932 0.100432 7 0.100098C7.32132 0.0997645 7.64279 0.266995 7.80802 0.601789L9.32911 3.68384L12.7304 4.17807C13.4685 4.28534 13.7633 5.19251 13.2291 5.7132L10.768 8.11224L11.349 11.4997C11.4751 12.235 10.7034 12.7956 10.0431 12.4485L7.00096 10.8491L3.95879 12.4485C3.29853 12.7956 2.52684 12.235 2.65294 11.4997L3.23394 8.11224L0.772773 5.7132C0.238609 5.19251 0.533365 4.28534 1.27156 4.17807L4.67281 3.68384ZM7 9.83616C7.14418 9.83601 7.28838 9.87047 7.41977 9.93955L10.3291 11.4691L9.77348 8.22947C9.72341 7.93751 9.8202 7.63961 10.0323 7.43285L12.386 5.13854L9.13328 4.66589C8.84014 4.62329 8.58673 4.43918 8.45564 4.17355L7.00096 1.22605L7 1.228V9.83616Z" fill="#FFC259"/>
  </svg>
</template>
